import React from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { useState, useEffect } from "react";
import LineChart from "../Charts/LineChart";
function Home() {
  const [dataArray, setDataArray] = useState([]);

  useEffect(() => {
    // getGridData();
  }, []);

  function getGridData() {
    let object = {} as any;
    axiosAuth
      .post(AppContext.AppBaseURL + "api/PFIBusinessPlan/GetTestData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data[1];
          setDataArray(l_response);

          console.log(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }


  return (
    <div>
      Home
    </div>
  );
}

export default Home;
